import {
  CACHE_KEY,
  CONDITIONAL_FORM,
  GeneralConfig,
} from "../utility/Constant";
import { invalidateTemplateFromCache } from "./cache.service";
import { EXISTING_FORMS } from "./form.helper.service";
import API, { getSSO } from "./http-helper.service";
const qs = require("qs");

export default class FormBuilderService {
  constructor() {
    const userSSO = localStorage.getItem("ge_sso")
      ? localStorage.getItem("ge_sso")
      : "";
    this.state = {
      configHeader: { includeUserId: true },
      userSSO: userSSO,
    };
  }

  getMyForms() {
    /*this path needs to be replaced once the actual api to fetch user-specific 
	  forms is built*/
    return API.get("builder/forms/metadata").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }
  isValidName(formName) {
    let baseUrl = "builder/forms/IsFormNameExist/";

    // Base64 encode the formName
    const encodedFormName = btoa(formName);
    return API.get(baseUrl + encodedFormName).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getTranslatedForm(translateData) {
    let baseUrl = "builder/forms/translate";
    return API.post(baseUrl, translateData).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  // This 'searchByFormName' returns the latest version or drafts of all forms
  searchByFormName(searchQuery, sortParameter, currentPage, sso = "") {
    let baseUrl =
      "builder/forms/search?page=" +
      (currentPage - 1) +
      "&size=" +
      EXISTING_FORMS.SIZE;
    if (sso) {
      baseUrl = baseUrl + "&userId=" + sso;
    }

    if (sortParameter.value && sortParameter.value !== "") {
      baseUrl =
        baseUrl + "&sort=" + sortParameter.value + "," + sortParameter.order;
    }
    return API.post(baseUrl, searchQuery).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  deleteForm(formId) {
    let baseUrl = "builder/forms/" + formId;
    return API.delete(baseUrl, this.state.configHeader).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  // This 'getAllForms' returns the metadata result of the latest versions or draft versions of the forms
  getAllForms(currentPage = 1, sortParameter = {}, sso = "") {
    let baseUrl =
      "builder/forms/metadata?page=" +
      (currentPage - 1) +
      "&size=" +
      EXISTING_FORMS.SIZE;
    if (sso) {
      baseUrl = baseUrl + "&userId=" + sso;
    }
    if (sortParameter.value && sortParameter.value !== "") {
      baseUrl =
        baseUrl + "&sort=" + sortParameter.value + "," + sortParameter.order;
    }
    return API.get(baseUrl).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getAllFormsByLatestVersionOnly(currentPage = 1, sortParameter = {}, sso = "") {
    let baseUrl =
      "builder/forms/metadataWithLatestVersion?page=" +
      (currentPage - 1) +
      "&size=" +
      EXISTING_FORMS.SIZE;
    if (sso) {
      baseUrl = baseUrl + "&userId=" + sso;
    }
    if (sortParameter.value && sortParameter.value !== "") {
      baseUrl =
        baseUrl + "&sort=" + sortParameter.value + "," + sortParameter.order;
    }
    return API.get(baseUrl).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getAllPreviousVersionForms(formCode) {
    return API.get(`builder/forms/previousVersions/${formCode}`).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      }
    );
  }

  getAllPublishedFormNames() {
    return API.get("builder/forms/getFormName", { includeUserId: true }).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getForm(formId) {
    return API.get("builder/forms/" + formId).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getFormCategories(formId) {
    return API.get("category/form/" + formId).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUniversalTypes() {
    return API.get("conditional/universalType").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUniversalTypeDetails(universalType) {
    return API.get(
      "conditional/universalTypeDetails/" + universalType,
      this.state.config,
    ).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getDependentDropdowns() {
    return API.get("dynamicDropdown").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  convertToFormData(form) {
    const currentTimestamp = new Date().valueOf();
    let categories = [];
    categories.push({
      id: form.business,
      categoryType: "Business",
      categoryName: undefined,
    });
    if (form.subbusiness)
      categories.push({
        id: form.subbusiness,
        categoryType: "Sub-Business",
        categoryName: undefined,
      });
    if (form.group)
      categories.push({
        id: form.group,
        categoryType: "Group",
        categoryName: undefined,
      });
    if (form.subgroup)
      categories.push({
        id: form.subgroup,
        categoryType: "Sub-Group",
        categoryName: undefined,
      });
    if (form.groupIds === undefined) form.groupIds = [];
    const formData = {
      id: form.id,
      formCode: form.formCode,
      version: form.version,
      publishedversion: form.publishedversion,
      formStatus: form.formStatus,
      title: form.title,
      assetType: "asset",
      description: form.description,
      defaultLanguageCode: form.language,
      createdBy: this.state.userSSO,
      createdDate: currentTimestamp,
      lastUpdatedBy: this.state.userSSO,
      lastUpdatedDate: currentTimestamp,
      keywords: form.keywords,
      children: [],
      requests: [],
      responses: null,
      formCategories: categories,
      enforceOrder: null,
      copiedFromFormCode: null,
      copiedFromFormVersion: null,
      customFormCode: null,
      isInLine: false,
      componentType: "form",
      hashCode: -641280495,
      groupIds: form.groupIds,
      formRegion: form.formRegion,
      formSiteRegion: form.formSiteRegion,
      formType: form.formType,
      universalHierarchy: form.universalHierarchy,
    };
    return formData;
  }

  createForm(form) {
    const currentTimestamp = new Date().valueOf();
    let categories = [];
    categories.push({
      id: form.business,
      categoryType: "Business",
      categoryName: undefined,
    });
    if (form.subbusiness)
      categories.push({
        id: form.subbusiness,
        categoryType: "Sub-Business",
        categoryName: undefined,
      });
    if (form.group)
      categories.push({
        id: form.group,
        categoryType: "Group",
        categoryName: undefined,
      });
    if (form.subgroup)
      categories.push({
        id: form.subgroup,
        categoryType: "Sub-Group",
        categoryName: undefined,
      });
    if (form.groupIds === undefined) form.groupIds = [];
    const formData = {
      version: null,
      publishedversion: null,
      title: form.title,
      assetType: "asset",
      formStatus: "Draft",
      description: form.description,
      defaultLanguageCode: form.language,
      createdBy: this.state.userSSO,
      createdDate: currentTimestamp,
      lastUpdatedBy: this.state.userSSO,
      lastUpdatedDate: currentTimestamp,
      keywords: form.keywords,
      children: [],
      requests: [],
      responses: null,
      formCategories: categories,
      enforceOrder: null,
      copiedFromFormCode: null,
      copiedFromFormVersion: null,
      customFormCode: null,
      isInLine: false,
      componentType: "form",
      hashCode: -641280495,
      groupIds: form.groupIds,
      formRegion: form.formRegion,
      formSiteRegion: form.formSiteRegion,
      ...(form.isConditionalForm && {
        universalHierarchy: form.universalHierarchy,
        formType: CONDITIONAL_FORM.CONDITIONAL,
      }),
    };
    return API.post("builder/forms", formData, this.state.configHeader).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  updateForm(formId, form) {
    const currentTimestamp = new Date().valueOf();
    form.lastUpdatedDate = currentTimestamp;
    form.lastUpdatedBy = getSSO();
    const updateURL = "builder/forms/" + formId;
    return API.put(updateURL, form, this.state.configHeader).then(
      (res) => {
        invalidateTemplateFromCache(CACHE_KEY.FORM_TEMPLATES, formId);
        return res;
      },
      (error) => {
        return { error: error };
      },
    );
  }

  updateTranslateForm(formId, translateForm) {
    const currentTimestamp = new Date().valueOf();
    translateForm.lastUpdatedDate = currentTimestamp;
    const updateURL = "builder/forms/" + formId;
    return API.put(updateURL, translateForm, this.state.configHeader).then(
      (res) => {
        return res;
      },
      (error) => {
        return { error: error };
      },
    );
  }

  async saveTranslation(payload) {
    try {
      const response = await API.post("builder/forms", payload, {
        includeUserId: true,
      });
      return response;
    } catch (error) {
      console.error("Error while saving translation :", error);
      return { error: error };
    }
  }

  copyForm(form) {
    const copyURL = "builder/forms/draft";
    const formData = this.convertToFormData(form);
    return API.post(copyURL, formData, this.state.configHeader).then(
      (res) => {
        return res;
      },
      (error) => {
        return { error: error };
      },
    );
  }

  getBarcodeTypes() {
    return API.get("customDataTypes").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserGroup(groupId) {
    return API.get("builder/groups/" + groupId).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserGroups() {
    return API.get("builder/groups").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  createUserGroup(groupData) {
    let userId = getSSO();
    let config = {
      headers: {
        userId: userId,
      },
    };
    return API.post("builder/groups", groupData, config).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  editUserGroup(groupData) {
    let userId = getSSO();
    let config = {
      headers: {
        userId: userId,
      },
    };
    const baseURL = "builder/groups/" + groupData.id;
    return API.put(baseURL, groupData, config).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  deleteUserGroup(groupId) {
    const baseURL = "builder/groups/delete/" + groupId;
    return API.put(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getOptionalEquipmentMapping(siteId) {
    let baseURL = "optionalEquipment/mapping?siteId=" + siteId;
    return API.get(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getAllUniqueCodes() {
    return API.get("builder/unique-codes");
  }

  getPromptList() {
    const promptBaseUrl = process.env.REACT_APP_BASE_URL_V2.replace(
      "/fw-service/v2",
      "/v2",
    );
    return API.get(`${promptBaseUrl}/prompt-mappings/promptList`, {
      includeUserId: true,
    });
  }

  getAllTurbinesBySite(siteId) {
    let baseURL = "builder/assetMgmt/turbines?siteId=" + siteId;
    return API.get(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  deleteOptionalEquipmentMapping(optionalEquipmentId) {
    let baseURL = "optionalEquipment/delete-by-id";
    return API.put(
      baseURL,
      { optionalEquipmentId: optionalEquipmentId },
      this.state.configHeader,
    ).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  createNewMapping(payload) {
    const currentTimestamp = new Date().valueOf();
    const mappingData = {
      siteId: payload.siteId,
      turbineId: payload.turbineId,
      optEquipId: payload.optionalEquipId,
      isActive: true,
      tenantId: "ren",
      createdBy: this.state.userSSO,
      createdDate: currentTimestamp,
      lastUpdatedBy: this.state.userSSO,
      lastUpdatedDate: currentTimestamp,
    };
    let baseURL = "optionalEquipment";
    return API.post(baseURL, mappingData, this.state.configHeader).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserDetails() {
    return API.get("user-mgmt/users").then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserSSODetails(sso) {
    let baseURL = "user-mgmt/users/ldap/" + sso;
    return API.get(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  addNewUser(payload) {
    let today = new Date();
    let month = "" + (today.getMonth() + 1);
    if (today.getMonth() + 1 < 10) month = "0" + month;
    let day = "" + today.getDate();
    if (today.getDate() < 10) day = "0" + day;
    let createdDate = today.getFullYear() + "-" + month + "-" + day;
    const userData = {
      sso: payload.sso,
      userFirstName: payload.firstName,
      userLastName: payload.lastName,
      email: payload.email,
      userRole: payload.role,
      tenantId: "ren",
      createdBy: this.state.userSSO,
      updateBy: this.state.userSSO,
      createdDate: createdDate,
      delete: false,
    };
    let baseURL = "user-mgmt/users";
    return API.post(baseURL, userData).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  updateUser(payload) {
    let today = new Date();
    let month = "" + (today.getMonth() + 1);
    if (today.getMonth() + 1 < 10) month = "0" + month;
    let day = "" + today.getDate();
    if (today.getDate() < 10) day = "0" + day;
    let updatedDate = today.getFullYear() + "-" + month + "-" + day;
    const userData = {
      id: payload.id,
      sso: payload.sso,
      userFirstName: payload.userFirstName,
      userLastName: payload.userLastName,
      email: payload.email,
      userRole: payload.userRole,
      tenantId: "ren",
      createdBy: payload.createdBy,
      updateBy: this.state.userSSO,
      createdDate: payload.createdDate,
      updatedDate: updatedDate,
      delete: false,
    };
    return API.put("user-mgmt/users", userData).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  deleteUser(userIds) {
    let baseURL = "user-mgmt/users?id=" + userIds;
    return API.delete(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserInfo(code) {
    let baseURL = "user-mgmt/users/userinfo/" + code;
    return API.get(baseURL).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getUserDetailsBySSO(sso) {
    return API.get("user-mgmt/users/" + sso).then(
      (res) => {
        return res;
      },
      (error) => {
        throw error;
      },
    );
  }

  async getLatestFormVersion(formCode) {
    return API.get(`builder/forms/latestVersion/${formCode}`).then(
      (res) => res,
      (error) => error,
    );
  }

  uploadImageDetails(fileObj) {
    let accept = "application/json";
    let contentType = "multipart/form-data";
    let userId = getSSO();
    let config = {
      headers: {
        Accept: accept,
        "Content-Type": contentType,
        userId: userId,
      },
    };
    var formData = new FormData();
    formData.append("file", fileObj.file);
    let imageId = fileObj.imageId;
    let url = "images/uploadImage?imageId=" + imageId + "";
    return API.post(url, formData, config)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return undefined;
      });
  }

  imageDetails(id, action) {
    let accept = "application/json";
    let contentType = "multipart/form-data";
    let userId = getSSO();
    let config = {
      headers: {
        Accept: accept,
        "Content-Type": contentType,
        userId: userId,
      },
    };
    if (action === GeneralConfig.DELETE)
      return API.delete("images/" + id + "", config)
        .then((response) => {
          return response;
        })
        .catch(() => {
          return undefined;
        });
    else if (action === GeneralConfig.GET)
      return API.get("images/" + id + "", config)
        .then((response) => {
          let data = response.data;
          data.imageId = id;
          return data;
        })
        .catch(() => {
          return undefined;
        });
  }
}
